import { isInStock } from "../../../utils/app-related/isInStock";
const assignQuantities = (options, remainingCount, quantities) => {
    if (remainingCount <= 0)
        return quantities;
    let assignmentMade = false;
    const updatedQuantities = { ...quantities };
    options.forEach(({ id, product: { sku } }) => {
        if (updatedQuantities[sku] > 0 && remainingCount > 0) {
            updatedQuantities[sku]--;
            updatedQuantities[id.toString()]++;
            remainingCount--;
            assignmentMade = true;
        }
    });
    return assignmentMade ? assignQuantities(options, remainingCount, updatedQuantities) : updatedQuantities;
};
export const getInitialSticks = (options, sticksCount, stockStatusElements) => {
    const queryParams = new URLSearchParams(window.location.search);
    const skuQuantities = Array.from(queryParams.entries()).reduce((acc, [key, value]) => {
        if (key.startsWith("sku_") && key.endsWith("_quantity")) {
            const sku = key.replace("sku_", "").replace("_quantity", "");
            acc[sku] = parseInt(value, 10);
        }
        return acc;
    }, {});
    const initialDistributedQuantities = options.reduce((acc, option) => {
        acc[option.id.toString()] = 0;
        return acc;
    }, {});
    const combinedQuantities = { ...initialDistributedQuantities, ...skuQuantities };
    const inStockOptions = options.filter((option) => isInStock(stockStatusElements[option.id]));
    const distributedQuantities = assignQuantities(inStockOptions, sticksCount, combinedQuantities);
    return Object.keys(distributedQuantities)
        .filter((key) => Object.hasOwnProperty.call(initialDistributedQuantities, key))
        .reduce((acc, key) => {
        if (distributedQuantities[key] > 0) {
            acc[key] = distributedQuantities[key];
        }
        return acc;
    }, {});
};
//# sourceMappingURL=getInitialSticks.js.map